import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "movies-faq-area pb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "row justify-content-center g-5",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_4 = { class: "movies-faq-content" }
const _hoisted_5 = { class: "accordion" }
const _hoisted_6 = { class: "accordion-header" }
const _hoisted_7 = ["aria-expanded", "onClick"]
const _hoisted_8 = { class: "accordion-collapse collapse show" }
const _hoisted_9 = { class: "accordion-body" }
const _hoisted_10 = { class: "movies-faq-bottom-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "section-title text-center mw-860 m-auto",
        "data-aos": "fade-up",
        "data-aos-duration": "1000",
        "data-aos-delay": "100"
      }, [
        _createElementVNode("h2", { class: "text-white" }, "لديك أسئلة؟ نحن هنا للمساعدة"),
        _createElementVNode("p", { class: "text-white" }, " جمعنا لك أكثر الأسئلة الشائعة التي يطرحها عملاؤنا لتسهيل بَدْء تجربتك معنا واكتشاف ميزات السيرفر. ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqGroups, (faqList, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col-lg-6 col-md-12"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqList, (faq, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["accordion-item", { active: _ctx.activeIndexes[index] === idx }]),
                    key: idx
                  }, [
                    _createElementVNode("h2", _hoisted_6, [
                      _createElementVNode("button", {
                        class: "accordion-button",
                        type: "button",
                        "aria-expanded": 
                      _ctx.activeIndexes[index] === idx ? 'true' : 'false'
                    ,
                        onClick: ($event: any) => (_ctx.toggleAccordion(index, idx))
                      }, _toDisplayString(faq.question), 9, _hoisted_7)
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", null, _toDisplayString(faq.answer), 1)
                      ])
                    ], 512), [
                      [_vShow, _ctx.activeIndexes[index] === idx]
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", null, [
          _cache[1] || (_cache[1] = _createTextVNode(" لم تجد إجابة لسؤالك؟ ", -1)),
          _createVNode(_component_RouterLink, { to: "/contact-us" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("تواصل معنا من هنا", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}